import { render, staticRenderFns } from "./q-details.vue?vue&type=template&id=306975ab&"
import script from "./q-details.vue?vue&type=script&lang=js&"
export * from "./q-details.vue?vue&type=script&lang=js&"
import style0 from "./q-details.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports